import { useTranslation } from 'react-i18next';

import Breadcrumbs from '../../../../../common/widgets/Breadcrumbs';
import applicationCrumbs from '../../ApplicationCrumbs';
import PlatformInformation from '../../Common/PlatformInformation';
import MyAccountMenu from '../Common/MyAccountMenu';

import { resources } from '../../../resources/resources';
import { TimeAndAttendance } from './Common/TimeAndAttendance';

export const TimeAndAttendancePage = () => {
  const { t: translate } = useTranslation();
  const crumbs = applicationCrumbs(translate);
  return (
    <>
      <Breadcrumbs
        entries={[
          crumbs.home,
          crumbs.accountDashboard,
          crumbs.timeAndAttendance,
        ]}
      />
      <section className="section-main section-actions my-account-page">
        <div className="container">
          <div className="area-actions">
            <MyAccountMenu />
          </div>
          <div className="area-content">
            <PlatformInformation />
            <div className="panel panel-time-and-attendance padding-xl">
              <div className="page-actions">
                <h1>{translate(resources.timeAndAttendance.title)}</h1>
              </div>
              <TimeAndAttendance />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
